import angular from 'angular';
import loansAmountSimulationErrorsComponent from './loansAmountSimulationErrors.component';

let loansAmountSimulationErrorsModule = angular.module('loansAmountSimulationErrors', [
])

.component('loansAmountSimulationErrors', loansAmountSimulationErrorsComponent)

.name;

export default loansAmountSimulationErrorsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulationErrors/loansAmountSimulationErrors.js